import { createFileRoute } from "@tanstack/react-router";
import { PathLabPage } from "@/routes/path-lab";

export const Route = createFileRoute("/patient-care/path-lab")({
  head: () => ({
    meta: [
      { title: "Path Lab — Healic Multispeciality Hospital | Blood Tests, Diagnostics & Home Collection" },
      { name: "description", content: "Healic Path Lab — NABL-grade blood tests, full body checkups, ECG, ultrasound and home sample collection across our Gurugram, Ghaziabad, Haridwar and Agra branches." },
      { property: "og:title", content: "Path Lab — Healic Multispeciality Hospital" },
      { property: "og:description", content: "NABL-grade lab tests, full body checkups & home sample collection at Healic Hospital." },
      { property: "og:url", content: "https://healic.in/patient-care/path-lab" },
    ],
    links: [{ rel: "canonical", href: "https://healic.in/patient-care/path-lab" }],
  }),
  component: PathLabPage,
});
